function Formatmessage(str) {
  if (typeof str !== "string") return str;

  const cleaned = str.replace(/_/g, " ").toLowerCase();

  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

export default Formatmessage;
